import { RequireCapability } from "@/components/RequireCapability";

import { ReportsApp } from "./components/ReportsApp";
// Registers the slice's reports.* translations (side-effect import).
import "./i18n";

/**
 * Administration / reports area (route: /admin). Enterprise list + detail,
 * progress dashboard, advanced search and the customizable assessment (charts),
 * built on the reports + filters API. Guarded by the `reports` capability.
 */
export function ReportsPage() {
  return (
    <RequireCapability required={["reports"]}>
      <ReportsApp />
    </RequireCapability>
  );
}
